exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-block-number[data-v-edfcac78]{position:absolute;top:-.4375rem;left:-.4375rem;min-width:.875rem;height:.875rem;padding:0 .1875rem;display:flex;align-items:center;justify-content:center;border-radius:10em;background-color:var(--fts-card-background);box-shadow:var(--fts-elevation-2);color:var(--fts-default);font-size:.5625rem;font-weight:600;line-height:1}", ""]);

// exports
